import React from 'react';
import { connect } from 'react-redux';

import AcceptCookies from 'components/AcceptCookies';
import { updateCurrentUser } from 'store/main/ducks/currentUser';
import { post } from 'utils/http';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/ban-types
type OwnProps = {};
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUser: Record<string, any>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateCurrentUser: (...args: Array<any>) => any;
};
type State = {
  submitting: boolean;
};

class AcceptCookiesContainer extends React.PureComponent<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    submitting: false,
  };

  acceptCookies = () => {
    this.setState({
      submitting: true,
    });
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 2-3 arguments, but got 1.
    post('/data/website/accept-cookies').then(() => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.updateCurrentUser({
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        ...this.props.currentUser,
        showAcceptCookies: false,
      });
      this.setState({
        submitting: false,
      });
    });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.currentUser.showAcceptCookies) return null;
    return (
      <AcceptCookies
        acceptCookies={this.acceptCookies}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        submitting={this.state.submitting}
      />
    );
  }
}

const mapStateToProps = ({ currentUser }) => ({
  currentUser,
});

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, {
  updateCurrentUser,
})(AcceptCookiesContainer);
